import { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MenuContext } from 'contexts';
import { device } from 'commons';

interface ComponentProps {
  children: ReactNode;
}

export function MenuProvider({ children }: ComponentProps) {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const retractableBreakPoint = device.tablet;

  const location = useLocation();

  useEffect(() => {
    setShowMenu(false);
  }, [location]);

  return (
    <MenuContext.Provider
      value={{
        retractableBreakPoint,
        showMenu,
        setShowMenu,
      }}
    >
      {children}
    </MenuContext.Provider>
  );
}
